// reducers/hostelReducer.js
export const hostelReducer = (
  state = { hostels: [], allocations: [] },
  action,
) => {
  switch (action.type) {
    case "HOSTEL_REQUEST":
      return { ...state, loading: true };
    case "GET_HOSTELS_SUCCESS":
      return { ...state, loading: false, hostels: action.payload };
    case "GET_ALLOCATIONS_SUCCESS":
      return { ...state, loading: false, allocations: action.payload };
    case "HOSTEL_FAIL":
      return { ...state, loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null };
    default:
      return state;
  }
};
